import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    stats: [],
    yearlySales: null,
    salesByLocation: null,
    loading: {
        stats: false,
        yearlySales: false,
        salesByLocation: false
    },
    error: null,
    selectedYear: new Date().getFullYear()
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setStatsLoading: (state, action) => {
            state.loading.stats = action.payload;
        },
        setYearlySalesLoading: (state, action) => {
            state.loading.yearlySales = action.payload;
        },
        setSalesByLocationLoading: (state, action) => {
            state.loading.salesByLocation = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            // Clear loading states when error occurs
            state.loading.stats = false;
            state.loading.yearlySales = false;
            state.loading.salesByLocation = false;
        },
        setStats: (state, action) => {
            state.stats = action.payload;
            state.loading.stats = false;
            state.error = null;
        },
        setYearlySales: (state, action) => {
            state.yearlySales = action.payload;
            state.loading.yearlySales = false;
            state.error = null;
        },
        setSalesByLocation: (state, action) => {
            state.salesByLocation = action.payload;
            state.loading.salesByLocation = false;
            state.error = null;
        },
        setSelectedYear: (state, action) => {
            state.selectedYear = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        resetDashboard: (state) => {
            state.stats = [];
            state.yearlySales = null;
            state.salesByLocation = null;
            state.error = null;
            state.loading = {
                stats: false,
                yearlySales: false,
                salesByLocation: false
            };
        }
    }
});

export const {
    setStatsLoading,
    setYearlySalesLoading,
    setSalesByLocationLoading,
    setError,
    setStats,
    setYearlySales,
    setSalesByLocation,
    setSelectedYear,
    clearError,
    resetDashboard
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
